import { whiteColor, backgroundColor } from 'assets/jss/material-dashboard-pro-react';

const customRepeatEveryStyle = () => ({
	repeatEveryWrapper: {
		backgroundColor: whiteColor,
		padding: '20px 0 20px 0',
		width: '100%',
		minWidth: '250px',
	},
	repeatEveryPeriodicityWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: '14px',
	},
	repeatPeriod: {
		marginTop: '15px',
		display: 'flex',
		alignItems: 'center',
	},
	labelRepeatPeriodWrapper: {
		width: 87,
	},
	repeatPeriodInput: {
		width: 72,
		marginLeft: '7px',
		marginRight: '16px',
		alignItems: 'center',
		padding: 0,
		'& .MuiFormControl-root': {
			paddingTop: 0,
			marginBottom: 0,
		},
		'& .MuiInputBase-input': {
			padding: 8,
			minWidth: '30px',
		},
	},
	labelRepeatEveryWrapper: {
		width: 87,
	},
	periodicityInput: {
		width: 72,
		marginLeft: '21px',
		marginRight: '16px',
		alignItems: 'center',
		padding: 0,
		'& .MuiFormControl-root': {
			paddingTop: 0,
			marginBottom: 0,
		},
		'& .MuiInputBase-input': {
			padding: 8,
			minWidth: '30px',
		},
	},
	periodSelect: {
		alignItems: 'center',
		width: 160,
		paddingLeft: '21px',
		display: 'flex',
		flexWrap: 'nowrap',
		'scrollbar-width': 'none',
		'-ms-overflow-style': 'none',
		'padding-left': '0px',
		'padding-right': '0px',
		'& > :not(style)': {
			flex: '0 0 auto',
			width: 124,
			margin: '0px 0px 0px 0px;',
			marginBottom: 0,
		},
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	selectedItem: {
		marginBottom: 0,
		'& .MuiInputBase-input': {
			padding: 0,
		},
	},
	repeatEveryDatesWrapper: {
		display: 'flex',
		flexDirection: 'column',
		width: 280,
	},
	repeatEveryDateRowWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginTop: '24px',
	},
	repeatEveryDateRowLabelWrapper: {
		width: '51px',
	},
	icon: {
		width: '16px',
		marginRight: '4px',
	},
	iconGray: {
		width: '16px',
		color: '#a4a4a4',
		marginLeft: '19px',
	},
	repeatEveryDateRowDateWrapper: {
		marginLeft: '8px',
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'& .MuiFormControl-root': {
			marginBottom: 0,
		},
		'& .MuiInputBase-input': {
			paddingBottom: 8,
		},
	},
	customRepeatSummaryWrapper: {
		backgroundColor: backgroundColor[0],
		display: 'flex',
		flexDirection: 'row',
		marginTop: '40px',
		padding: '16px',
		maxWidth: '340px',
		minWidth: '250px',
	},
	summaryInfo: {
		padding: '8px',
	},
	customRepeatSummaryLine1Wrapper: {
		display: 'flex',
		flexDirection: 'column',
		paddingTop: '10px',
	},
	customRepeatSummaryLine2Wrapper: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: '8px',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	customRepeatSummaryToDate: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	customRepeatSummaryFrom: {},
	customRepeatSummaryStartDate: {
		display: 'flex',
		flexDirection: 'row',
		paddingLeft: '8px',
		alignItems: 'center',
	},
	customRepeatSummaryTo: {
		paddingLeft: '16px',
	},
	customRepeatSummaryEndDate: {
		display: 'flex',
		flexDirection: 'row',
		paddingLeft: '8px',
		alignItems: 'center',
	},
	dateTooltipInfo: {
		marginLeft: '10px',
	},
});

export default customRepeatEveryStyle;
